import stripTrailingSlash from 'lib/stripTrailingSlash';

import { getEnvValue } from './utils';

const apiHost = getEnvValue('NEXT_PUBLIC_API_HOST');
const apiPingClientId = getEnvValue('NEXT_PUBLIC_PING_CLIENT_ID');
const apiRedirectUri = getEnvValue('NEXT_PUBLIC_REDIRECT_API');
const apiSchema = getEnvValue('NEXT_PUBLIC_API_PROTOCOL') || 'https';
const apiPort = getEnvValue('NEXT_PUBLIC_API_PORT');
const apiEndpoint = [ apiHost ]
  .filter(Boolean)
  .join('');

const socketSchema = 'wss';
const socketEndpoint = [ socketSchema, '://', apiHost?.split('://')?.[1] ]
  .filter(Boolean)
  .join('');

const api = Object.freeze({
  host: apiHost,
  protocol: apiSchema,
  port: apiPort,
  apiPingClientId,
  apiRedirectUri,
  endpoint: apiEndpoint,
  socket: socketEndpoint,
  basePath: stripTrailingSlash(getEnvValue('NEXT_PUBLIC_API_BASE_PATH') || ''),
});

export default api;
